import { FormControl, TextField } from '@mui/material';
import { FC, useState, useEffect } from 'react';
import { useRecoilRefresher_UNSTABLE, useRecoilState } from 'recoil';
import { ApiClient } from 'TaxAnalyticsHelpers';
import { EntityDTO } from 'TaxAnalyticsHelpers/TaxAnalyticsClient';
import { DeloitteDialog } from '../Deloitte';
import { DeloitteDialogProps } from '../Deloitte/DeloitteDialog';
import { fetchUserEntities, selectedEntityState } from 'TaxAnalyticsState/userState';


interface EditEntityModalProps extends DeloitteDialogProps {
    entity?: EntityDTO;
}

export const EditEntityModal: FC<EditEntityModalProps> = (props) => {
    const { entity, title, closeCallback, ...rest } = props;
    const refreshEntities = useRecoilRefresher_UNSTABLE(fetchUserEntities);
    const getInitialFormState = () => {
        if (entity)
            return {
                id: entity.id,
                name: entity.name,
                siret: ''
            }
        return {
            id: '',
            name: '',
            siret: ''
        }

    }

    const [entityState, setEntityState] = useState(getInitialFormState());
    const [, setCurrentEntity] = useRecoilState(selectedEntityState);

    const handleChange = (event: any) => {
        setEntityState({ ...entityState, [event.target.name]: event.target.value });
    };
    const handleSubmit = async (callback: any) => {
        //event.preventDefault();
        const req = {
            ...entityState,
            id: entityState.id !== '' ? entityState.id : undefined
        };
        var entity: EntityDTO;
        if (entityState.id !== '')
            entity = await ApiClient.entityClient.update(req);
        else
            entity = await ApiClient.entityClient.add(req);
        setEntityState({ ...entityState, id: entity.id ?? '' });
        refreshEntities();
        setCurrentEntity(entity);
        callback(entity);
    };

    useEffect(() => {
        setEntityState(getInitialFormState());
    }, [entity]);

    return <DeloitteDialog title={title ? title : entity ? "Edition" : "Création"} closeCallback={() => closeCallback(null)} {...rest} bottomAction={() => handleSubmit(closeCallback)} actionTitle={entityState.id !== '' ? 'Modifier' : 'Créer'}>
        <form>
            <FormControl fullWidth component="fieldset">
                <TextField
                    id="name"
                    name="name"
                    label="Nom de l'entité"
                    onChange={handleChange}
                    value={entityState.name}
                    required
                    variant="standard"
                />
                {/*<TextField*/}
                {/*    id="siret"*/}
                {/*    name="siret"*/}
                {/*    label="Siret"*/}
                {/*    onChange={handleChange}*/}
                {/*    required*/}
                {/*    variant="standard"*/}
                {/*/>*/}
            </FormControl>
        </form>
    </DeloitteDialog>
}